import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import { Badge, Card, ErrorText, Spinner } from '@/components/ui'
import { BackupsPage } from '@/pages/settings/backups/BackupsPage'

import { AdminGuard } from './AdminGuard'

type ServiceSettings = {
  app_base_url: string
  environment: string
  test_deployment: boolean
  smtp_configured: boolean
  integrations: { kind: string; allowed: boolean }[]
}
const labels: Record<string, string> = { email: 'Почта', ai: 'ИИ', garmin: 'Garmin', push: 'Push-уведомления', s3: 'S3' }

export function AdminSettingsPage() {
  return <AdminGuard><ServiceContent /></AdminGuard>
}

function ServiceContent() {
  const query = useQuery({ queryKey: ['admin', 'service-settings'], queryFn: () => api.get<ServiceSettings>('/admin/settings') })
  return <div className="grid gap-5">
    <Card title="Сервис и подключения" subtitle="Параметры окружения меняются в Environment сервиса Dokploy и применяются после Deploy. Секреты здесь не показываются.">
      {query.isPending ? <Spinner /> : query.isError ? <ErrorText error={query.error} /> : <>
        <dl className="grid gap-x-6 gap-y-2 text-sm sm:grid-cols-[auto_1fr]">
          <dt className="text-muted">Адрес сайта</dt><dd className="break-words">{query.data.app_base_url}</dd>
          <dt className="text-muted">Окружение</dt><dd>{query.data.environment}</dd>
          <dt className="text-muted">Тестовая установка</dt><dd>{query.data.test_deployment ? 'Да' : 'Нет'}</dd>
          <dt className="text-muted">SMTP</dt><dd>{query.data.smtp_configured ? 'Настроен' : 'Не настроен'}</dd>
        </dl>
        <ul className="mt-4 divide-y divide-border">{query.data.integrations.map((item) => <li key={item.kind} className="flex items-center justify-between gap-3 py-3 text-sm">
          <span>{labels[item.kind] ?? item.kind}</span><Badge tone={item.allowed ? 'accent' : 'neutral'}>{item.allowed ? 'Разрешено' : 'Запрещено'}</Badge>
        </li>)}</ul>
        <p className="mt-3 text-sm text-muted">Разрешение подключения не означает, что его реквизиты заполнены. Для почты нужны SMTP_*, для S3 — S3_*; внешние вызовы управляются APP_TEST_DEPLOYMENT и APP_ALLOW_*.</p>
      </>}
    </Card>
    <BackupsPage />
  </div>
}
